import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../../Actions/Dialogs/DialogActions";
import { showSafeDropForm } from "../../../../Actions/SellScreen/SellScreenActions";
import Button from "../../../../Common/Buttons/Button";
import PopupManager from "../../../../Common/Popups/PopupManager";
import { type RootState } from "../../../../Reducers/ShopfrontReducers";
import { getOption } from "../../../../Utilities/Platform/Options/Options";
import { openDrawer } from "../../../../Workers/HardwareConnect/HardwareConnectEvents";

function mapStateToProps(state: RootState): {
    register: null | string;
} {
    return {
        register: state.location.register ? state.location.register.id : null,
    };
}

const connector = connect(mapStateToProps);

interface Props extends ConnectedProps<typeof connector> {
    dispatch: ThunkDispatch<any, any, any>;
}

class SafeDropRequiredDialog extends React.Component<Props> {
    public componentDidMount(): void {
        window.addEventListener("keydown", this.handleWindowKeyPress);
    }

    public componentWillUnmount(): void {
        window.removeEventListener("keydown", this.handleWindowKeyPress);
    }

    protected handleWindowKeyPress = (): void => {
        this.props.dispatch(hideDialog());
    };

    protected handleIgnoreClick = (): void => {
        this.props.dispatch(hideDialog());
    };

    protected handlePerformClick = (): void => {
        if(getOption("register_never_open_cash_drawer")) {
            this.props.dispatch(showSafeDropForm());

            return;
        }

        openDrawer({
            from    : "Safe Drop",
            register: this.props.register as string,
            reason  : "Performing a safe drop",
            callback: (reason, error) => {
                if(error) {
                    // Print Open Drawer screen
                    if(typeof window !== "undefined") {
                        const w = window.open("", "Open Drawer", "width=800,height=600,toolbar=0,menubar=0,location=0");

                        if(w) {
                            w.document.write("<p>Open Drawer</p>");
                            w.onafterprint = (): void => {
                                // Requires request animation frame due to maximum call stack exceeded error otherwise
                                requestAnimationFrame(() => {
                                    this.props.dispatch(showSafeDropForm());
                                });
                                w.close();
                            };
                            w.focus();
                            w.print();
                        } else {
                            PopupManager.warning("Popup Blocked, please allow popups for this website");
                        }
                    }
                } else {
                    this.props.dispatch(showSafeDropForm());
                }
            },
        });
    };

    public render(): React.ReactNode {
        return (
            <div className="safe-drop-required">
                <div className="buttons">
                    <Button onClick={this.handleIgnoreClick} classes={[ "button-cancel" ]}>Ignore</Button>
                    <Button onClick={this.handlePerformClick} classes={[ "button-save" ]}>Perform</Button>
                </div>
            </div>
        );
    }
}

export default connector(SafeDropRequiredDialog);
